var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Customer = /** @class */ (function () {
    function Customer(props) {
        Object.assign(this, props);
    }
    return Customer;
}());
export { Customer };
var CustomerSales = /** @class */ (function (_super) {
    __extends(CustomerSales, _super);
    function CustomerSales() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CustomerSales;
}(Customer));
export { CustomerSales };



//////////////////
// WEBPACK FOOTER
// ./src/modules/Customers/Model.ts
// module id = 324
// module chunks = 0